module.exports = __webpack_public_path__ + "img/folder.daeb9dec.svg";